import ListIcon from '@/components/icons/list';
import MapIcon from '@/components/icons/map';
import { TopbarTab } from '@/components/topbar/topbar';
import { getWorkspaceRoute } from '@/utils/routes';

export function TopbarActions() {
  return (
    <div className="flex h-full items-center">
      <TopbarTab href={getWorkspaceRoute('/locations')} label="Location List" icon={<MapIcon />} />
      <TopbarTab href={getWorkspaceRoute('/locations/location-logs')} label="Location Logs" icon={<ListIcon />} />
    </div>
  );
}
